module.exports = __webpack_public_path__ + "static/media/ApplicationNew.d958ee33.svg";